import React from 'react';
import PropTypes from 'prop-types';
import { CheckBoxPopup, MultipleChoicePopup, SelfServeBuilderPopupTypes } from 'Popups';
import CustomPropTypes from 'CustomPropTypes';
import PopupGroupBox from './PopupGroupBox';

const { CHECKBOX, MULTIPLE_CHOICE } = SelfServeBuilderPopupTypes;

class PopupGroup extends React.PureComponent {
  render() {
    const groupedPopupIds = this.props.popupGroup.fieldIds;
    const commonGroupPopupProps = {
      addPaddingTop: this.props.addPaddingTop,
      bounds: `.page[data-page-number='${this.props.pageIndex + 1}']`,
      draggable: this.props.isDraggable(this.props.groupId),
      groupId: this.props.groupId,
      popupGroup: this.props.popupGroup,
      resizable: this.props.isResizeable(this.props.groupId),
      isPreviewMode: this.props.isPreviewMode,
      zoomFactor: this.props.zoomFactor,
    };

    return (
      <React.Fragment>
        {this.props.isActive &&
          <PopupGroupBox
            addPaddingTop={this.props.addPaddingTop}
            getSuperScriptValue={this.props.getSuperScriptValue}
            groupId={this.props.groupId}
            popupGroup={this.props.popupGroup}
            popupsInGroup={this.props.popupsInGroup}
          />
        }
        {
          groupedPopupIds.map((id) => {
            commonGroupPopupProps.data = this.props.popupsInGroup[id];
            commonGroupPopupProps.id = id;
            commonGroupPopupProps.key = id;
            switch (this.props.popupGroup.type) {
              case CHECKBOX:
                return (
                  <CheckBoxPopup
                    {...commonGroupPopupProps}
                  />
                );
              case MULTIPLE_CHOICE:
                return (
                  <MultipleChoicePopup
                    {...commonGroupPopupProps}
                  />
                );
              default:
                return null;
            }
          })
        }
      </React.Fragment>
    );
  }
}


PopupGroup.propTypes = {
  addPaddingTop: PropTypes.func.isRequired,
  getSuperScriptValue: PropTypes.func.isRequired,
  groupId: PropTypes.string.isRequired,
  isActive: PropTypes.bool.isRequired,
  isDraggable: PropTypes.func.isRequired,
  isPreviewMode: PropTypes.bool.isRequired,
  isResizeable: PropTypes.func.isRequired,
  pageIndex: PropTypes.number.isRequired,
  popupGroup: PropTypes.shape({
    label: PropTypes.string,
    type: PropTypes.oneOf([
      CHECKBOX,
      MULTIPLE_CHOICE,
    ]).isRequired,
    pageIndex: PropTypes.number,
    fieldIds: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  popupsInGroup: CustomPropTypes.hashmapOf(
    PropTypes.shape({
      label: PropTypes.string,
      type: PropTypes.string,
    }),
  ).isRequired,
  zoomFactor: PropTypes.number.isRequired,
};

export default PopupGroup;



// WEBPACK FOOTER //
// ./src-react/PopupGroup/index.jsx